// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__B6Ldu","title":"style_title__6xTpM","list":"style_list__8oFwJ"};